// extracted by mini-css-extract-plugin
module.exports = {"pointer":"navelement_pointer__15ES_","active":"navelement_active__16WWp","upcoming":"navelement_upcoming__2TDSh","completed":"navelement_completed__2wBM9"};